import '@neux/ui-jquery/neux-ui-jquery';
import { preventIEError } from '@neux/ui-jquery/tool';
import mobileMenu from './mobileMenu.js';
import scrollUpShowHeader from './scrollUpShowHeader.js';
import { addOpenWindowText, getData, repairZero } from './util';

function initializePage() {
	getData('qa', 'GET', renderData);
}

function main() {
	// init
	preventIEError();
	initializePage();
	// for api
	scrollUpShowHeader();
	mobileMenu();
}

function createQaBox(qaData) {
	const $collapseContainer = $('<div />', {
		class: 'collapse-container'
	});

	$.each(qaData, function (index, qaItem) {
		const $collapse = $('<div />', {
			class: 'collapse'
		});
		// collapse__title的內容
		const $collapseTitle = $('<h3 />', {
			class: 'collapse__title',
			tabindex: 0,
			role: 'button'
		});
		$('<div />', {
			class: 'collapse__tag',
			text: repairZero(qaItem.id)
		}).appendTo($collapseTitle);
		$('<div />', {
			class: 'collapse__text',
			text: qaItem.question
		}).appendTo($collapseTitle);
		$('<span />', {
			class: 'collapse__cross'
		}).appendTo($collapseTitle);

		$collapseTitle.appendTo($collapse);

		// collapse__content的內容
		let $collapseContent = $('<div />', {
			class: 'collapse__content'
		});
		$('<div />', {
			class: 'neux-editor',
			html: addOpenWindowText(qaItem.answer)
		}).appendTo($collapseContent);

		$collapseContent.appendTo($collapse);

		$collapse.appendTo($collapseContainer);
	});

	return $collapseContainer;
}

function renderData(data) {
	let $itemNav = $('<div />', {
		class: 'tab__nav'
	});
	let $itemContent = $('<div />', {
		class: 'tab__content'
	});

	$.each(data.datas, (index, tabItem) => {

		const domId = `#tab__box${index + 1}`;
		// 每個tab__link
		$('<div />', {
			class: 'tab__link',
			text: tabItem.name,
			tabindex: 0,
			'refer-to': domId,
		}).appendTo($itemNav);

		// 每個tab__content
		let $tabBox = $('<div />', {
			id: domId,
			class: 'tab-content__box',
		});

		// tab內容
		// 無標題
		if (tabItem.qas?.length) {

			const $collapseContainer = createQaBox(tabItem.qas);

			// 如果為空就不塞入.tab-content__box
			if ($collapseContainer.html() != '') {
				$collapseContainer.appendTo($tabBox);
			}
		}

		// 有標題
		if (tabItem.types?.length) {

			$.each(tabItem.types, function (index, collapseItem) {
				// 有問與答資料
				if (collapseItem.qas?.length) {

					// 每個收合項目的標題
					const $collapseTitle = $('<div />', {
						class: 'tab-content-box__title h6',
						text: collapseItem.name
					});

					const $collapseContainer = createQaBox(collapseItem.qas);

					// 如果為空就不塞入.tab-content__box
					if ($collapseContainer.html() != '') {
						$tabBox.append($collapseTitle, $collapseContainer);
					}
				}
			});
		}

		$tabBox.appendTo($itemContent);
	});

	$('#qa-tab').append($itemNav, $itemContent);

	// 綁相關套件
	additionFn();
}

function additionFn() {
	$('.tab').nxJqTab({
		navSelector: '.tab__nav',//填入所使用的導覽列class或選擇器
		containerSelector: '.tab__content'//填入所使用的內容容器class或選擇器
	});
	$('.tab__link').on('keydown', function (e) {
		if (e.keyCode === 13) {
			$(this).trigger('click');
		}
	});

	$('.collapse').nxJqCollapse({
		parent: false, //是否要受同層收合影響
		listType: false,  //是否需要項目符號
	});
	$('.tab__content').on('keydown', '.collapse__title', function (e) {
		if (e.keyCode === 13) {
			if ($(this).hasClass('active')) {
				$(this).parent().nxJqCollapse('hide');
			} else {
				$(this).parent().nxJqCollapse('show');
			}
		}
	});
}

main();